<template lang="pug">
.q-mb-sm.q-mx-md.q-pa-md.drugstore-card(:id="drugstore.id")
    base-full-spinner.fixed.full-height-vh(v-if="loading")
        template(v-slot:spinner)
            q-spinner-dots(
                size="40px"
                color="positive")
    .relative-position
        q-btn.absolute-top-right(
            v-if="userAuthorized"
            flat
            fab-mini
            @click.prevent.stop="updateFavourite")
            q-icon(
                name="etabl:heart"
                size="24px"
                dense
                :color="isFavourite || currentFav ? 'negative' : 'grey-7'")
        .row.items-center.q-mb-sm
            q-img(
                v-if="drugstore.brandUrl"
                :src="drugstore?.brandUrl"
                style="max-width: 85px; height: 44px"
                fit="contain"
            )
            q-img(
                v-else
                src="logo_t.t.svg"
                style="max-width: 85px; height: 44px"
                fit="contain"
            )
            .font-14.text-weight-600.q-ml-md
                | {{ drugstore?.title ? drugstore?.title : 'Табле.Точка' }}
    //.text-weight-medium(v-if="!appointment") {{ drugstore.geo.cityName }}
    //.text-weight-medium(v-else) {{ drugstore.city.name }}
    template(v-if="!appointment")
        .font-14.text-positive {{ formatAddress(drugstore.geo.address) }}
    .font-14(v-else) {{ formatAddress(drugstore.address) }}
    .font-12.q-mt-md(v-if="!currentDrugstoreSchedule && !appointment") График работы:
        strong.text-positive Круглосуточно
    q-expansion-item(
        v-if="currentDrugstoreSchedule && !appointment"
        :label="`График работы: ${currentDrugstoreSchedule}`"
    )
        q-scroll-area(
            :horizontal-thumb-style="{display: 'none'}"
            style="height: 70px; width: 100%;max-width: 600px"
        )
            .row.q-px-xs.no-wrap
                .day.q-pa-xs.text-center.no-wrap(
                    v-for="(day, index) in drugstore.schedule"
                    :key="index"
                    :class="{'bordered-positive b-radius-8' : day.day === today, 'border-from-date' : onlyFromDate}"
                    :style="[day.day === today ? 'background-color: rgba(231, 247, 232, 0.4)' : '',`width: 70px `]"
                )
                    .text-positive.font-14 {{ day.dayName }}
                    .text-primary.font-12 {{ day.start }}
                    .text-primary.font-12 {{ day.end }}
                    .text-primary.font-12(v-if="!day.start") Вых.

    .q-ml-md.q-mt-md(v-if="appointment")
        base-btn(
            :disable="!drugstore.isReceptionAvailable"
            width="178"
            bradius="16"
            height="32"
            font_size="12"
            :color="onlyFromDate ? 'yellow-6' : 'positive'"
            :label="drugstore.isReceptionAvailable ? 'Выбрать этот салон' : 'Запись недоступна'"
            @click="setDrugstore")
    .q-ml-md.q-mt-xs(v-if="addressChoose")
        base-btn(
            width="178"
            bradius="16"
            height="32"
            font_size="12"
            color="positive"
            label="Искать в этой аптеке"
            @click="setAddress")
    .full-width(
        v-if="productPage"
    )
        .col-grow
            slot(name="bages")
    .full-width.text-dark.transition-all.q-px-md(
        v-if="drugstore.list_items?.length"
        @click="show = !show")
        .row.items-center
            .col-grow
                slot(name="bages")
            q-icon.q-ml-lg.q-mt-xs(
                :color="show ? 'positive' : 'grey-12'"
                name="etabl:arrow_down"
                size="14px"
                :class="[show ? 'rotate-180' : '', 'transition-all']")
        q-slide-transition(:duration="200")
            div(v-show="show")
                .row.font-12.text-weight-regular.q-py-xs(
                    v-for="item in drugstore.list_items")
                    .col-6.text-grey-11.text-ellipsis {{ item.name }}
                    .col-2.text-grey-9.text-center {{ item.amount }} / {{ item.available }}
                    .col-4.app-primary.text-right.text-weight-bold {{ item.price }} ₽
                template(v-if="drugstore.list_not_available?.length")
                    .font-12.text-weight-bold {{ methodWayGet[0] == 2 ? 'Заказать со склада' : 'Недоступны для заказа со склада' }}
                    .row.font-12.text-weight-regular.q-py-xs(v-for="item in drugstore.list_not_available")
                        .col-6.text-grey-11.text-ellipsis {{ item.name }}
    base-btn.q-mt-md(
        :label="'Маршрут'"
        :height="'40'"
        :background="'transparent'"
        :text_color="'positive'"
        :outline="true"
        :icon="'near-me'"
        :icon_color="'positive'"
        font_size="14"
        bradius="16"
        centred
        :gapLabel="'8px'"
        @click="getRouteToPharmacy(drugstore.geo.location)"
    )
    slot(name="button")
</template>

<script>
import { computed, inject, ref } from 'vue';
import { useStore } from 'vuex';
import BaseBtn from 'components/Base/BaseBtn.vue';
import BaseFullSpinner from 'components/Base/BaseFullSpinner.vue';
import { useRoute } from 'vue-router';

export default {
    name: 'DrugstoreListMobile',
    components: {
        BaseBtn,
        BaseFullSpinner,
    },
    props: {
        drugstore: {
            type: Object,
            required: true,
        },
        currentProduct: {
            type: Object,
            default: () => null,
        },
        basket: {
            type: Boolean,
        },
        userFavouriteDrugstores: {
            type: Array,
        },
        productPage: {
            type: Boolean,
        },
        appointment: {
            type: Boolean,
            default: () => false,
        },
        addressChoose: {
            type: Boolean,
            default: () => false,
        },
        onlyFromDate: {
            type: Boolean,
            default: () => false,
        },
    },
    setup(props, { emit }) {
        const store = useStore();
        const route = useRoute();
        // состояние загрузки
        const loading = ref(false);

        const timer = ref();
        const show = ref(false);
        const product = inject('product');
        const today = computed(() => new Date().getDay());

        const userAuthorized = computed(() => store.getters['user/USER_AUTHORIZED']);
        const isFavourite = computed(() => props.userFavouriteDrugstores?.includes(props.drugstore.id));

        const currentFav = ref(isFavourite.value);

        // значение "забрать сегодня"
        const isToday = computed(() => store.getters['basket/BASKET_IS_TODAY']);

        // способ получения
        const methodWayGet = computed(() => store.getters['basket/BASKET_METHOD_WAY_GET']);

        const updateFavourite = async () => {
            window?.TapticEngine?.unofficial.weakBoom();

            if (timer.value) {
                clearTimeout(timer.value);
            }

            timer.value = setTimeout(async () => {
                isFavourite.value || currentFav.value
                    ? deleteDrugstoreFromUserFav()
                    : addDrugstoreToUserFav();

                currentFav.value = !currentFav.value;
            }, 300);


        };

        const deleteDrugstoreFromUserFav = async () => {
            try {
                await store.dispatch('user/DELETE_FAVOURITE_DRUGSTORE', props.drugstore.id);
                await store.commit('user/DELETE_USER_FAVOURITE_DRUGSTORE', props.drugstore.id);
            } catch (e) {
                console.log(e);
            }
        };

        const addDrugstoreToUserFav = async () => {
            try {
                await store.dispatch('user/ADD_FAVOURITE_DRUGSTORE', props.drugstore.id);
                await store.commit('user/ADD_USER_FAVOURITE_DRUGSTORE', props.drugstore.id);
            } catch (e) {
                console.log(e);
            }
        };

        // время работы выбранной аптеки
        const currentDrugstoreSchedule = computed(() => {
            if (props.drugstore.isDayAndNight) {
                return 'Круглосуточно';
            }
            let day;

            if (props.drugstore.schedule?.length)
                if (today.value > 0) {
                    day = props.drugstore.schedule
                        .find((item) => item.day === today.value);
                } else if (today.value == 0) {
                    day = props.drugstore.schedule
                        .find((item) => item.day === 7);
                }

            if (props.drugstore.schedules?.length)
                if (today.value > 0) {
                    day = props.drugstore.schedules
                        .find((item) => item.dayNumber === today.value);
                } else if (today.value == 0) {
                    day = props.drugstore.schedule
                        .find((item) => item.dayNumber === 7);
                }

            if (day && props.appointment) {
                if (!day.workingTime.begin) {
                    return 'Выходной';
                }
                if (day.workingTime.begin == '00:00') {
                    return false;
                } else {
                    return `Сегодня ${day.workingTime.begin} - ${day.workingTime.end}`;
                }
            }

            if (day) {
                if (!day.start) {
                    return 'Выходной';
                }
                if (day.start == '00:00') {
                    return false;
                } else {
                    return `Сегодня ${day.start} - ${day.end}`;
                }
            }
            return null;
        });

        const formatAddress = (address) => {
            if (!address) return '';

            return address
                .split(',')
                .map((part) => part.trim())
                .filter(
                    (part) =>
                        !/^\d+$/.test(part) &&
                        !/обл/i.test(part) &&
                        !/(р-н|район)\s*[^,]*/i.test(part),
                )
                .join(', ');
        };

        const setDrugstore = async () => {
            loading.value = true;

            emit('setDrugstore', props.drugstore);

            loading.value = false;
        };

        const setAddress = async () => {
            emit('setAddress', props.drugstore);
        };

        const getRouteToPharmacy = (location)=>{
            if(route.name === 'Product'){
                try {
                    ym(72234883,'reachGoal','product-directions-click');
                    
                }catch (err){
                    
                }
            }else {
                try {
                    
                }catch (err){
                    ym(72234883,'reachGoal','click-route-addressMap');
                }

            }
            window.open(`https://yandex.ru/maps?rtext=~${location.lat},${location.lon}&rtt=auto`, '_blank');
            
            //window.open(`https://yandex.ru/maps/?mode=routes&rtext=~${location.lat}%2C${location.lon}rtt=auto&ruri=~&z=12`, '_blank');
        };

        return {
            show,
            today,
            product,
            loading,
            isFavourite,
            setDrugstore,
            methodWayGet,
            userAuthorized,
            updateFavourite,
            currentDrugstoreSchedule,
            deleteDrugstoreFromUserFav,
            addDrugstoreToUserFav,
            currentFav,
            setAddress,
            formatAddress,
            getRouteToPharmacy,
        };
    },
};
</script>

<style lang="scss" scoped>
.drugstore-active {
    background-color: #F1F9F3;
}

.day {
    width: 14.2857%;
}

:deep(.q-expansion-item .q-item) {
    font-size: 14px;
    min-height: 0;
    color: $primary;
    padding: 4px 0;

    @media screen and (max-width: 320px) {
        font-size: 12px;
    }
}

:deep(.q-item__label) {
    font-size: 13px;
    font-weight: 500;
}

.drugstore-card {
    border-radius: 16px;
    background: #FFF;
    box-shadow: 2px 1px 5px 0px rgba(0, 0, 0, 0.05);
}

</style>
